const e = (o) => typeof document > "u" || typeof window > "u" ? null : document.getElementById(o || "portalContainer");
export {
  e as getModalPortal
};
